<script>
  import ArrowLeft2 from "./ArrowLeft.vue";
  import Eye from "./Eye.vue";
  import EyeHide from "./EyeHide.vue";
  import Check from './Check.vue';
  import CopyRight from "./CopyRight.vue";
  import ArrowRight from "./ArrowRight.vue";

  export default {
    name: 'icon-rd',
    props: {
      color: {
        type: String,
        default: 'default',
      },
      name: {
        type: String,
        required: true,
      },
      isHovered: {
        type: Boolean,
      },
      size: {
        type: String,
      }
    },
    computed: {
      iconClass() {
        return {
          'icon-primary': this.color === 'primary',
          'icon-disabled': this.color === 'disabled',
          'icon-hovered': this.isHovered,
          'icon-default': this.color === 'default',
          'icon-light': this.color === 'light',
          [`icon__${this.size}`]: !!this.size,
        }
      }
    },
    components: {
      'arrow-left': ArrowLeft2,
      'eye': Eye,
      'eye-hide': EyeHide,
      'check': Check,
      'copy-right': CopyRight,
      'arrow-right': ArrowRight,
    }
  }
</script>

<template>
  <span class="icon">
    <component :is="name" :class="iconClass" />
  </span>
</template>

<style scoped lang="less">
  @import "../../less/redesign/vars.less";

  .icon {
    display: inline-block;
    vertical-align: middle;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 0;
    line-height: 0;
    &__xs {
      width: 16px;
      height: 24px;
    }
    &__sm {
      width: 24px;
      height: 24px;
    }
  }
  .icon-default {
    stroke: @primary-dark;
  }
  .icon-primary {
    stroke: @primary-blue;
  }
  .icon-disabled {
    stroke: @grey-input;
  }
  .icon-hovered {
    stroke: @secondary-active !important;
  }
  .icon-light {
    stroke: @primary-light;
  }
</style>



// WEBPACK FOOTER //
// src/ui/icon/Icon.vue